import { useState, useEffect } from 'react';

/**
 * Returns the current window inner width, updating on resize.
 * Use this in components that have inline styles and need mobile breakpoints.
 */
const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
};

export default useWindowWidth;
